import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import emailjs from "emailjs-com";
import "./ContactMe.css";

import loading from "../../Assets/contactMe/loading.gif";

import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";

export default function ContactMe(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const subscription = ScrollService.currentScreenFadeIn.subscribe(
      (screen) => {
        if (screen.fadeInScreen !== props.id) return;
        Animations.animations.fadeInScreen(props.id);
      }
    );
    return () => subscription.unsubscribe();
  }, [props.id]);

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const submitForm = (e) => {
    e.preventDefault();

    if (name.trim().length === 0 || email.trim().length === 0 || message.trim().length === 0) {
      setBanner("Tous les champs sont requis.");
      toast.error("Tous les champs sont requis.");
      return;
    }

    if (name.trim().length < 2) {
      setBanner("Le nom doit contenir au moins 2 caractères.");
      toast.error("Le nom doit contenir au moins 2 caractères.");
      return;
    }

    if (!isValidEmail(email)) {
      setBanner("Veuillez entrer une adresse email valide.");
      toast.error("Veuillez entrer une adresse email valide.");
      return;
    }

    if (message.trim().length < 10) {
      setBanner("Le message doit contenir au moins 10 caractères.");
      toast.error("Le message doit contenir au moins 10 caractères.");
      return;
    }

    setIsSubmitting(true);
    setBanner("");

    const templateParams = {
      from_name: name,
      from_email: email,
      message: message,
    };

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams
    )
      .then(() => {
        setBanner("Message envoyé avec succès !");
        toast.success("Message envoyé avec succès !");
        setIsSubmitting(false);
        setName("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.error("Erreur lors de l'envoi du message :", error);
        setBanner("Une erreur est survenue, veuillez réessayer.");
        toast.error("Une erreur est survenue, veuillez réessayer.");
        setIsSubmitting(false);
      });
  };

  return (
    <div className="contact-container fade-in" id={props.id || ""}>
      <ScreenHeading title={"Contact"} subHeading={"Restons en contact"} />

      <div className="contact-content">
        <div className="contact-links">
          <a
            href="/CV_Souleimane_ZEGGAI.pdf"
            download
            className="contact-link-item"
          >
            <i className="fa fa-download"></i>
            <span>Télécharger mon CV</span>
          </a>
          <a
            href="https://github.com/souleimane-z"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link-item"
          >
            <i className="fa fa-github"></i>
            <span>github.com/souleimane-z</span>
          </a>
          <a
            href="https://www.linkedin.com/in/souleimane-zeggai/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link-item"
          >
            <i className="fa fa-linkedin"></i>
            <span>linkedin.com/in/souleimane-zeggai</span>
          </a>
        </div>

        <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={submitForm}>
            <div className="form-status" role="alert" aria-live="polite">{banner}</div>

            <div className="form-group">
              <label htmlFor="name">Nom</label>
              <input
                type="text"
                id="name"
                className="form-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Votre nom"
                required
                minLength={2}
                aria-required="true"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Votre email"
                required
                aria-required="true"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                className="form-input"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Votre message..."
                required
                minLength={10}
                aria-required="true"
              />
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <div className="loader">
                  <img src={loading} alt="Chargement" />
                </div>
              ) : (
                <>
                  Envoyer <i className="fa fa-paper-plane"></i>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
